module.exports = __webpack_public_path__ + "img/yixiaoxing_head.b180f766.png";